export const ServiciosActionTypes = {
  API_RESPONSE_SUCCESS: '@@servicios/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@servicios/API_RESPONSE_ERROR',

  GET_SERVICIO: '@@servicios/GET_SERVICIO',
  LIST_SERVICIOS: '@@servicios/LIST_SERVICIOS',
  ADD_SERVICIO: '@@servicios/ADD_SERVICIO',
  UPDATE_SERVICIO: '@@servicios/UPDATE_SERVICIO',
  DELETE_SERVICIO: '@@servicios/DELETE_SERVICIO',

  RESET: '@@servicios/RESET'
}
